import React, { useState, useEffect } from 'react';
import axios from 'axios';

const InstantQuotePage = () => {

    const [form, setForm] = useState({
        name: '',
        email: '',
        phone: '',
        quantity: '100',
        sides: 'double'
    });

    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [timeLeft, setTimeLeft] = useState('');
    const [success, setSuccess] = useState(false);
    const [liveMsg, setLiveMsg] = useState('');

    const prices = {
        single: { 100: 15, 300: 25, 500: 35 },
        double: { 100: 22, 300: 32, 500: 42 }
    };

    const currentPrice = prices[form.sides][form.quantity];

    // ?? COUNTDOWN
    useEffect(() => {
        const target = new Date('2026-05-20T23:59:59');

        const interval = setInterval(() => {
            const now = new Date();
            const diff = target - now;

            if (diff <= 0) return setTimeLeft('Offer Ended');

            const d = Math.floor(diff / (1000 * 60 * 60 * 24));
            const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const m = Math.floor((diff / (1000 * 60)) % 60);

            setTimeLeft(`${d}d ${h}h ${m}m`);
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // ?? FAKE LIVE SOCIAL PROOF
    useEffect(() => {
        const msgs = [
            'New order from Nicosia',
            'Customer just ordered 500 cards',
            'Business client uploaded files',
            'New request from Limassol',
        ];

        const interval = setInterval(() => {
            const random = msgs[Math.floor(Math.random() * msgs.length)];
            setLiveMsg(random);

            setTimeout(() => setLiveMsg(''), 3000);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formData = new FormData();

            formData.append('product', 'Business Cards Promo');
            formData.append('quantity', form.quantity);
            formData.append('customer_name', form.name);
            formData.append('customer_email', form.email);
            formData.append('customer_phone', form.phone);
            formData.append('options', JSON.stringify({
                sides: form.sides,
                price: currentPrice
            }));

            if (file) formData.append('files', file);

            await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/quotes`,
                formData,
                { withCredentials: true }
            );

            if (window.gtag) {
                window.gtag('event', 'conversion', {
                    send_to: 'AW-17953980284/G3tjCOT-1_gbEPz-j_FC',
                    value: currentPrice,
                    currency: 'EUR'
                });
            }

            setSuccess(true);

        } catch {
            alert('Error sending request');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F5F3ED]">

            {/* HERO */}
            <div className="bg-[#1a1410] text-white text-center py-16 px-4">
                <h1 className="text-4xl font-bold mb-3">
                    PREMIUM BUSINESS CARDS
                </h1>

                <p className="opacity-80">
                    350gsm • 5.5x9 cm • Full Colour
                </p>

                <div className="mt-4 text-yellow-400 font-bold">
                    Ends in: {timeLeft}
                </div>

                {/* CTA */}
                <button
                    onClick={() => document.getElementById('orderForm').scrollIntoView({ behavior: 'smooth' })}
                    className="mt-6 bg-[#C6A87A] px-6 py-3 rounded font-bold"
                >
                    ORDER NOW
                </button>
            </div>

            {/* OFFER IMAGE */}
            <div className="max-w-4xl mx-auto mt-8 px-4">
                <img
                    src="/images/business-cards-offer.png"
                    className="rounded-xl shadow"
                    alt="offer"
                />
            </div>

            {/* PRICES */}
            <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6 px-6 py-10">

                {['single', 'double'].map((type) => (
                    <div key={type} className={`bg-white p-6 rounded-xl shadow ${type === 'double' ? 'border-2 border-[#C6A87A]' : ''}`}>
                        <h2 className="text-xl font-bold mb-4">
                            {type === 'single' ? 'ONE SIDE' : 'DOUBLE SIDE'}
                        </h2>

                        {[100, 300, 500].map(q => (
                            <div key={q}>{q} cards — €{prices[type][q]}</div>
                        ))}

                        <button
                            onClick={() => {
                                setForm({ ...form, sides: type });
                                document.getElementById('orderForm').scrollIntoView({ behavior: 'smooth' });
                            }}
                            className={`mt-4 w-full py-2 rounded ${form.sides === type ? 'bg-black text-white' : 'border'
                                }`}
                        >
                            Select
                        </button>
                    </div>
                ))}

            </div>

            {/* FORM */}
            <div className="max-w-2xl mx-auto bg-white p-8 rounded-xl shadow mb-24">

                {success && (
                    <div className="bg-green-100 text-green-700 p-4 rounded mb-4 text-center">
                        Thank you. Request received! We will call you shortly.
                    </div>
                )}

                <h3 className="text-2xl font-bold mb-6 text-center">
                    Order Now
                </h3>

                <form id="orderForm" onSubmit={handleSubmit} className="space-y-4">

                    <div className="text-red-600 text-center font-bold text-sm">
                         Offer ends in {timeLeft}
                    </div>

                    <select
                        className="w-full p-3 border rounded"
                        value={form.quantity}
                        onChange={(e) => setForm({ ...form, quantity: e.target.value })}
                    >
                        <option value="100">100 Cards</option>
                        <option value="300">300 Cards</option>
                        <option value="500">500 Cards</option>
                    </select>

                    <input
                        required
                        placeholder="Full Name"
                        className="w-full p-3 border rounded"
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                    />

                    <input
                        placeholder="Email (optional)"
                        className="w-full p-3 border rounded"
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />

                    <input
                        required
                        placeholder="Phone"
                        className="w-full p-3 border rounded"
                        onChange={(e) => setForm({ ...form, phone: e.target.value })}
                    />

                    <input type="file" onChange={(e) => setFile(e.target.files[0])} />

                    <div className="text-center text-lg font-bold">
                        Total: €{currentPrice}
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 font-bold rounded bg-[#C6A87A]"
                    >
                        {loading ? 'Sending...' : 'ORDER NOW'}
                    </button>

                    <p className="text-xs text-center text-gray-500">
                        No payment now • We contact you within 30 minutes
                    </p>

                </form>
            </div>

            {/* LIVE POPUP */}
            {liveMsg && (
                <div className="fixed bottom-6 left-6 bg-green-600 text-white px-4 py-2 rounded shadow">
                    {liveMsg}
                </div>
            )}

            {/* STICKY BUTTONS */}
            <div className="fixed bottom-6 right-6 flex flex-col gap-3 z-[9999]">
                <a href="tel:25366249" className="bg-green-600 text-white px-5 py-3 rounded-full font-bold shadow">
                     Call
                </a>

                <button
                    onClick={() => document.getElementById('orderForm').scrollIntoView({ behavior: 'smooth' })}
                    className="bg-black text-white px-5 py-3 rounded-full font-bold shadow"
                >
                    Order
                </button>

                <a
                    href={`https://wa.me/35799668181?text=I want ${form.quantity} business cards (${form.sides})`}
                    className="bg-green-500 text-white px-5 py-3 rounded-full font-bold shadow"
                >
                    WhatsApp
                </a>
            </div>

        </div>
    );
};

export default InstantQuotePage;